module.exports = {
	"entityMap": {
		"0": {
			"type": "LINK",
			"mutability": "MUTABLE",
			"data": {
				"href": "http://www.facebook.com",
				"url": "http://www.facebook.com/"
			}
		}
	},
	"blocks": [
		{
			"key": "3to3l",
			"text": "Bold text, Italic text, unstyled text\nExample link",
			"type": "unstyled",
			"depth": 0,
			"inlineStyleRanges": [
				{
					"offset": 0,
					"length": 9,
					"style": "BOLD"
				},
				{
					"offset": 11,
					"length": 11,
					"style": "ITALIC"
				}
			],
			"entityRanges": [
				{
					"offset": 38,
					"length": 12,
					"key": 0
				}
			],
			"data": {}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/compose/data.json
// module id = 861
// module chunks = 0